import React, { useMemo, useState } from 'react';
import classNames from 'classnames/bind';

import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import styles from './ModalRestaurant.styl';
import Modal from '../../../../Modal';
import Paper from '../../../../Paper';
import PizzaIcon from '../../../../../icons/pizzaIcon.svg';
import Button from '../../../../Button';

const cx = classNames.bind(styles);

export default function ModalRestaurant() {
  const intl = useIntl();

  const currentRestaurant = useSelector(state => state.order.checkout.currentRestaurant);

  const restaurantInfo = useMemo(() => {
    return {
      name: currentRestaurant?.name || '',
      address: currentRestaurant?.address || '',
      responsible_for_media_services: currentRestaurant?.responsible_for_media_services || '',
      owner: currentRestaurant?.owner || '',
      software_from: currentRestaurant?.software_from || '',
    };
  }, [currentRestaurant]);

  const [isModalForPapa, setModalForPapa] = useState(false);
  const openModalPapaHandler = () => setModalForPapa(true);
  const closeModalPapaHandler = () => setModalForPapa(false);
  const blocks = [
    <div className={cx('ModalRestaurant__block')} key={1}>
      <div className={cx('ModalRestaurant__title')}>
        {intl.formatMessage({ id: 'modal.restaurant.address' })}
      </div>
      <div className={cx('ModalRestaurant__description')}>{restaurantInfo?.name}</div>
      <div className={cx('ModalRestaurant__description')}>{restaurantInfo?.address}</div>_ _ _ _ _ _
      _ _ _ _ _ _ _ _ _ _ _ _ _ _ _ _
    </div>,

    <div className={cx('ModalRestaurant__block')} key={2}>
      <div className={cx('ModalRestaurant__title')}>
        {intl.formatMessage({ id: 'modal.restaurant.responsible' })}
      </div>
      <div className={cx('ModalRestaurant__description')}>
        {restaurantInfo?.responsible_for_media_services}
      </div>
    </div>,

    <div className={cx('ModalRestaurant__block')} key={3}>
      <div className={cx('ModalRestaurant__title')}>
        {intl.formatMessage({ id: 'modal.restaurant.owner' })}
      </div>
      <div className={cx('ModalRestaurant__description')}>{restaurantInfo?.owner}</div>_ _ _ _ _ _ _
      _ _ _ _ _ _ _ _ _ _ _ _ _ _ _
    </div>,

    <div className={cx('ModalRestaurant__block')} key={4}>
      <div className={cx('ModalRestaurant__title')}>
        {intl.formatMessage({ id: 'modal.restaurant.software' })}
      </div>
      <div className={cx('ModalRestaurant__description')}>{restaurantInfo?.software_from}</div>
    </div>,
  ];
  const middle = Math.ceil(blocks.length / 2);
  const leftColumn = blocks.slice(0, middle);
  const rightColumn = blocks.slice(middle);

  const clearCheckout = () => {
    window.localStorage.removeItem('checkout');
    window.location.reload();
  };
  return (
    <div className={cx('ModalRestaurant')}>
      <Button
        className={cx('ModalRestaurant__button')}
        type="button"
        onClick={openModalPapaHandler}
      >
        <PizzaIcon width="28" height="28" />
        <div className={cx('ModalRestaurant__button_text')}>
          {intl.formatMessage({ id: 'modal.restaurant.button' })}
        </div>
      </Button>

      <Modal isOpen={isModalForPapa} onClose={closeModalPapaHandler}>
        <Paper className={cx('ModalRestaurant__container')}>
          <div className={cx('ModalRestaurant__legalinfo')}>
            {intl.formatMessage({ id: 'modal.restaurant.legalinfo' })}
          </div>
          <div className={cx('ModalRestaurant__information')}>
            <div className={cx('ModalRestaurant__column')}>{leftColumn}</div>

            <div className={cx('ModalRestaurant__column')}>{rightColumn}</div>
          </div>
          <div className={cx('ModalRestaurant__goaway')}>
            {intl.formatMessage({ id: 'modal.restaurant.goaway' })}
          </div>
          <div className={cx('ModalRestaurant__goaway')}>
            {intl.formatMessage({ id: 'modal.restaurant.goaway2' })}
          </div>
          <div className={cx('ModalRestaurant__buttons')}>
            <Button className={cx('ModalRestaurant__cancelButton')} onClick={clearCheckout}>
              <div className={cx('ModalRestaurant__cancelButton_text')}>
                {intl.formatMessage({ id: 'modal.restaurant.cancel' })}
              </div>
            </Button>
            <Button
              className={cx('ModalRestaurant__okButton')}
              type="button"
              onClick={closeModalPapaHandler}
            >
              <div className={cx('ModalRestaurant__okButton_text')}>
                {intl.formatMessage({ id: 'modal.restaurant.ok' })}
              </div>
            </Button>
          </div>
        </Paper>
      </Modal>
    </div>
  );
}
